export default __webpack_public_path__ + "static/media/pause.835cb50a.svg";